import { DatePicker } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useHistory, useLocation } from 'react-router-dom'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import { DATE_FORMAT_DEFAULT, ISO_DATE_FORMAT } from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import ExportTimeKeepingToExcel from './ExportTimeKeepingToExcel'
const { RangePicker } = DatePicker
const TimeManagementPage = props => {
  const location = useLocation()
  const history = useHistory()
  // check hiển thị phân trang khi load dữ liệu
  const [queryStringParsed, setQueryStringParsed] = useState(
    queryString.parse(location.search, {
      arrayFormat: 'index',
    })
  )

  useEffect(() => {
    setQueryStringParsed({
      ...queryStringParsed,
      ...{
        fromDate: moment(new Date()).startOf('month').format('YYYY-MM-DD'),
      },
      ...{
        toDate: moment(new Date()).endOf('month').format('YYYY-MM-DD'),
      },
    })
    history.push(`/time-management?${queryString.stringify(queryStringParsed)}`)
  }, [])

  const onChange = value => {
    setQueryStringParsed({
      ...queryStringParsed,
      ...{
        fromDate: value ? moment(value[0]._d).format(ISO_DATE_FORMAT) : null,
      },
      ...{ toDate: value ? moment(value[1]._d).format(ISO_DATE_FORMAT) : null },
    })
    history.push(`/time-management?${queryString.stringify(queryStringParsed)}`)
  }

  const onChangeExport = async () => {
    history.push(`/time-management?${queryString.stringify(queryStringParsed)}`)
  }

  const onClose = async () => {
    history.push(`/time-management?${queryString.stringify(queryStringParsed)}`)
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Danh sách chấm công</title>
      </Helmet>
      <PageTitle location={props.location}></PageTitle>
      <ContentBlockWrapper style={{ minHeight: 'calc(100vh - 150px)' }}>
        <RangePicker
          style={{ marginRight: 5 }}
          onChange={onChange}
          value={
            queryStringParsed.fromDate && queryStringParsed.toDate
              ? [
                  moment(queryStringParsed.fromDate),
                  moment(queryStringParsed.toDate),
                ]
              : null
          }
          format={[DATE_FORMAT_DEFAULT, DATE_FORMAT_DEFAULT]}
        />
        <ExportTimeKeepingToExcel
          onChangeExport={onChangeExport}
          onCloser={onClose}
          params={queryStringParsed}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

TimeManagementPage.propTypes = {}

export default inject()(observer(TimeManagementPage))
